import { API_VERSIONS } from "../utils/constants";
import RequestHandler from "./RequestHandler";

function SuppliersAPI() {
    const baseSuppliersAPI = "suppliers";

    async function getSuppliers(
        itemsPerPage,
        filters,
        offset = 0,
        defaultSortBy = null,
        defaultSortDirection = null
    ) {
        try {
            const skip = offset * itemsPerPage;
            const sortBy = defaultSortBy || "name";
            const sortDirection = defaultSortDirection || "ASC";
            let URL = `${API_VERSIONS.v1}/${baseSuppliersAPI}/list?skip=${skip}&take=${itemsPerPage}&sortBy=${sortBy}&sortDirection=${sortDirection}`;
            const result = await RequestHandler.post(URL, filters);
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function createSupplier(supplierData) {
        try {
            const result = await RequestHandler.post(
                `${API_VERSIONS.v1}/${baseSuppliersAPI}`,
                supplierData
            );

            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function updateSupplier(updates) {
        try {
            const result = await RequestHandler.put(
                `${API_VERSIONS.v1}/${baseSuppliersAPI}`,
                updates
            );

            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function deleteSupplier(supplierId) {
        try {
            const result = await RequestHandler.remove(
                `${API_VERSIONS.v1}/${baseSuppliersAPI}/${supplierId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    return {
        getSuppliers,
        createSupplier,
        updateSupplier,
        deleteSupplier,
    };
}

export default SuppliersAPI();
